import { APICore } from "../apiCore";
import { getGuildApiParams } from "../../Guild/guildUtils";

const api = new APICore();

function getShowDetailPage(genreSlug: string, showSlug: string) {
  return api.get(`/genre/${ genreSlug }/show/${ showSlug }`, getGuildApiParams());
}

function getShowAwards(genreSlug, showSlug) {
  return api.get(`/genre/${genreSlug}/show/${showSlug}/award`, getGuildApiParams());
}

function getShowAwardCounts(genreSlug, showSlug) {
  return api.get(`/genre/${genreSlug}/show/${showSlug}/award`, getGuildApiParams());
}


export { getShowDetailPage, getShowAwards, getShowAwardCounts };